export const nftContractAddress = "0x6B5CCC5Eb0647B85c195d10D33C1FE0603987418" //mainnet
//export const nftContractAddress = "0xecc2236e7ACB77A13Aaa6c52b13C17230267ae1C" //sepolia
//export const nftContractAddress = "0xF023D7c6959273ec96fe1eC87cBA956A1a85c078"  //goerli
export const openseaProdAddress = "https://opensea.io/assets/ethereum/0x6b5ccc5eb0647b85c195d10d33c1fe0603987418/"
export const cost = 0.08